<template>
  <div v-show="visible" class="loading-mask">
    <div class="loading-add"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
    }
  },
}
</script>

<style lang="scss" scoped>
.loading-mask {
  position: absolute;
  width: 100%;
  height: 100%;
  top:0;
  left:0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: hsla(0, 0%, 100%, 0.9);
  transition: opacity 0.3s;
  z-index: 2007;
}

.loading-add {
  width: 30px;
  height: 30px;
  border: 2px solid #5577ff;
  border-top-color: transparent;
  border-radius: 100%;
  animation: add infinite 0.75s linear;
}
@keyframes add {
  0% {
    transform: rotateZ(0);
  }

  100% {
    transform: rotateZ(360deg);
  }
}
</style>